import { styled } from '@mui/material';

import { FileUploadIconProps } from 'src/components/fileUpload/types';

const StyledIcon = styled('div')<FileUploadIconProps>(({ theme, isError }) => ({
  color: isError ? theme.palette.error.main : theme.palette.primary.main
}));

export default StyledIcon;
